import type { Fetcher } from 'route-data/fetcher-types';
import { getIsEligibilityLoaded } from 'redux/modules/shop-by-list/selectors';
import { getShopByListEligibility } from 'redux/modules/shop-by-list/actions/get-shop-by-list-eligibility';

export const shopByListEligibilityFetcher: Fetcher = () => (dispatch, getState) => {
  const state = getState();
  const isEligibilityLoaded = getIsEligibilityLoaded(state);

  if (isEligibilityLoaded) {
    return Promise.resolve();
  }

  return dispatch(getShopByListEligibility());
};
